export * from './CertificationsTable';
